import React, { Fragment, useRef } from "react";
import _ from "lodash";

import RegisterFields from "./RegisterFields";
import TicketFields from "./ticketFields";

export const TicketForm = (props) => {
  const inputRef = useRef({});
  console.log(props.patientData);
  const renderFields = () => {
    return _.map(
      TicketFields,
      ({
        label,
        name,
        type,
        options,
        required,
        disabled,
        description,
        autoFilled,
      }) => {
        // Determine if field should be disabled based on whether it's auto-filled and has data
        const shouldDisableField =
          autoFilled &&
          props.patientData &&
          props.patientData[name] &&
          props.patientData[name] !== "";

        return (
          <RegisterFields
            name={name}
            label={label}
            type={type}
            value={
              name === "hn"
                ? props.patientData.hn
                : name === "firstname"
                ? props.patientData.firstname
                : name === "lastname"
                ? props.patientData.lastname
                : name === "warranty"
                ? props.patientData.warranty
                : name === "productSn"
                ? props.patientData.productSn
                : name === "purchaseDate"
                ? props.patientData.purchaseDate
                : name === "brand"
                ? props.patientData.brand
                : name === "model"
                ? props.patientData.model
                : name === "serviceOrderNumber"
                ? props.serviceOrderNumber
                : inputRef.current.name
            }
            fileNames={props.fileNames}
            defaultfiles={props.defaultfiles}
            options={options}
            required={required}
            initailValue={
              props.initailValues ? props.initailValues[name] : null
            }
            onChange={props.onChange(name)}
            disabled={disabled || shouldDisableField}
            description={description}
            product={props.product}
            onViewFile={props.onViewFile}
            ticketId={props.ticketId}
            onProductFound={props.onProductFound} // Pass the callback
          />
        );
      }
    );
  };

  return <Fragment>{renderFields()}</Fragment>;
};
